import { css } from "@emotion/css";
import { Tooltip } from "@octopusdeploy/design-system-components";
import { colorScales } from "@octopusdeploy/design-system-tokens";
import React from "react";
export const CloseButton = ({ onClick }: {
    onClick: () => void;
}) => (<div className={closeIconStyles} onClick={onClick}>
        <Tooltip content={`Close project status`} position="bottom" distance={25}>
            <em className={`fa fa-times-circle`}/>
        </Tooltip>
    </div>);
const closeIconStyles = css({
    color: colorScales.grey[500],
    fill: colorScales.grey[500],
    fontSize: "20px",
    marginLeft: "auto",
    cursor: "pointer",
});
